import React from 'react'
import './style.scss'
import logoSm from "../../assets/images/logo-in-white.png";
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import AgencyDropdownFullWidth from 'Components/Common/AgencyDropdownFullWidth';
const OnboardingLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    const onboardingSteps = useSelector((state: RootState) => state.auth.selectedAgency?.onboarding_steps)

    const totalOnboardingSteps = Object.keys(onboardingSteps ?? {}).length;
    const completedOnboardingSteps = Object.values(onboardingSteps ?? {}).filter((step) => step.status === 'complete').length;

    return (
        <div className='onboarding-layout'>
            <div className="onboarding-layout__header">
                <img src={logoSm} alt="logo" height={25} />
                <AgencyDropdownFullWidth />
            </div>
            <div className="onboarding-layout__content">
            <div className="onboarding-layout__content__bg"></div>
                <div className='onboarding-layout__progress'>
                    <div className='onboarding-layout__progress__bar' style={{ width: `${(completedOnboardingSteps / totalOnboardingSteps) * 100}%` }}></div>
                </div>
                {children}
            </div>
        </div>
    )
}

export default OnboardingLayout